import styled from 'styled-components';

export const Container = styled.div<{ timeContainer?: boolean }>`
  font-family: 'Source Sans Pro';
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  margin-top: 0.5rem;
  .hefesto-progress {
    width: 16.88rem;
  }

  .hefesto-progress__label {
    display: none;
  }
`;

export const ItemText = styled.span`
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.grayDark3};
  margin-bottom: 1.5rem;
`;

export const Description = styled.span`
  font-family: 'Work Sans';
  color: ${({ theme }) => theme.colors.grayDark4};
  margin-top: 0.5rem;
  line-height: 1.5rem;
`;

export const ProgressContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    flex-direction: column;
    align-items: start;
    gap: 0;
  }
`;

export const Counter = styled.span`
  font-family: 'Work Sans';
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grayDark4};
  line-height: 1.5rem;
`;
